import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { ToastContainer, toast } from 'react-toastify';
import { LoadingSpinner } from '../../../../components/Loader/Loader';
import http, { httpUser } from '../../../../config/BaseUrl'

function AccountInfo({user}) {

  
  const { register, handleSubmit, formState: { errors }, reset } = useForm({
    mode: "onChange",
    reValidateMode: "all"
  });

  const [isLoading, setLoading] = useState(false)
  useEffect(()=>{
    if (user) {
      reset({
        first_name: user.first_name,
        last_name: user.last_name,
      })
    }
  }, [user])

  const handelInfo = (data) => {
    setLoading(true)
    const submittedData = {
      ...data,
      email: user.email
    }
    http.post('/update/user', submittedData)
      .then(res => {
        toast.success("Profile updated successfully")
        setLoading(false)
      })
      .catch(err => {
        console.log(err)
      })
  }

  return (
    <div className='card'>
      <div className='card-header'>
        <h6 className='font-weight-bold'>Account Information</h6>
      </div>
      <form onSubmit={handleSubmit(handelInfo)}>
        <div className='card-body'>
          <div className='form-group'>
            <label>First Name</label>
            <input 
              {...register("first_name", { required: "Please fill up the first name" })}
              type='text'
              className='form-control' 
              placeholder='First Name'
              />
              <span className="text-danger font-size-14">{errors.first_name && errors.first_name.message}</span>
          </div>
          <div className='form-group'>
            <label>Last Name</label>
            <input 
              {...register("last_name", { required: "Please fill up the last name" })}
              type='text' 
              className='form-control' 
              placeholder='Last Name' 
              />
              <span className="text-danger font-size-14">{errors.last_name && errors.last_name.message}</span>
          </div>
          <div className='form-group'>
            <label>Email</label>
            <input type='email' className='form-control' disabled value={user?.email} placeholder='Email' />
          </div>
        
        </div>
        <div className='card-footer text-right'>
          {isLoading ?
              (<button className="btn btn-primary rounded-pill px-4" disabled>
                  <LoadingSpinner color="text-white" className="spinner-grow-sm" />
              </button>)
              : 
              <button type='submit' className='btn btn-primary rounded-pill px-4'>Save</button>
            }
        </div>
      </form>
      <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
    </div>
  )
}

export default AccountInfo